import React from "react";
import { useNavigate } from "react-router-dom";
import CTAs from "./CTAs";

const InstructionCard = ({
  title,
  description,
  status,
  statusBg,
  statusText,
  label,
  labelBg,
  labelText,
  date,
  navigateTo,
}) => {
  const navigate = useNavigate();

  return (
    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start">
      <div className="w-full rounded-t-3xs rounded-b-none bg-white box-border flex flex-col items-start justify-start p-6 gap-6">
        <div className="self-stretch flex flex-row items-start justify-between gap-0">
          <div className="flex-1 flex flex-col items-start justify-start gap-2.5">
            <div className="self-stretch relative font-semibold">{title}</div>
            <div className="self-stretch relative text-neutrals-neutral-300">
              {description}
            </div>
          </div>
          <div
            className={`rounded-xl border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm ${statusBg} ${statusText} border-${statusText}`}
          >
            <div
              className={`w-1.5 relative rounded-[50%] h-1.5 ${statusText} bg-current`}
            />
            <div className="relative font-semibold">{status}</div>
          </div>
        </div>
        <div className="self-stretch flex flex-col items-start justify-start gap-2.5 text-neutrals-neutral-300">
          <div className="flex flex-row items-center justify-start gap-1.5">
            <img
              className="w-5 relative h-5"
              alt="Calendar"
              src="assets/calendar.svg"
            />
            <div className="relative">{date}</div>
          </div>
          <div className="rounded-8xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm text-neutrals-neutral-900">
            <div
              className={`w-1.5 relative rounded-[50%] h-1.5 bg-current ${labelText}`}
            />
            <div className="relative font-semibold">{label}</div>
          </div>
        </div>
      </div>
      <div className="w-full border-neutrals-neutral-100 border-solid border-t-[1px] box-border flex flex-col items-end justify-start py-4 px-6 text-sm">
        <CTAs
          type="Secondarybtn"
          text="View details"
          borderColor="border-neutrals-neutral-100"
          onClick={() => navigate(navigateTo)}
        />
      </div>
    </div>
  );
};

export default InstructionCard;
